export function getLocalDate(dateString: string | Date): string {
	return new Date(dateString).toLocaleDateString("pt-BR", {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
	});
}
